export const SEARCH_ASSISTANT_USERS_REQUEST = "SEARCH_ASSISTANT_USERS_REQUEST";
export const SEARCH_DOCTOR_USERS_REQUEST = "SEARCH_DOCTOR_USERS_REQUEST";
